module.exports = __webpack_public_path__ + "img/avatar-8.66214557.jpeg";